import type { DocumentType } from "~/services/documents";
import type { AxleDocument } from "~/types";

export const getAxleData = <T>(
  document?: (Omit<AxleDocument<T>, "id"> & { id?: string }) | null,
  type?: DocumentType,
) => {
  if (!document) {
    return null;
  }

  if (type) {
    return document.data[`axle.${type}`];
  }

  return Object.values(document.data)[0];
};
